import axios from '@/lib/axios';
import { PromoCareOrderParams } from '../types';

const createPromoCare = (data: PromoCareOrderParams) => {
  return axios.post('/facility/orders/promo_care', data);
}

export default createPromoCare;